import React, { useState } from "react";
import "./App.css";
import { Routes, Route, Link, useLocation } from "react-router-dom";
import Home from "./pages/Home";
import Contact from "./pages/Contact";
import Resume from "./pages/Resume";
import Projects from "./pages/Projects";
import Chat from "./pages/Chat";

function App() {
  const location = useLocation();
  const path = location.pathname.replace(/\/+$/, "").toLowerCase(); // trim trailing slashes
  const hideHeader = path === "" || path === "/" || path === "/home"; // treat / and /home as landing
  const [navOpen, setNavOpen] = useState(false);

  return (
    <div className="App">
      {!hideHeader && (
        <header className="App-header glass-header">
          <div className="nav-inner">
            <button
              className="nav-toggle"
              type="button"
              aria-label="Toggle navigation menu"
              aria-expanded={navOpen}
              onClick={() => setNavOpen((open) => !open)}
            >
              <span className="nav-toggle-bar" />
              <span className="nav-toggle-bar" />
              <span className="nav-toggle-bar" />
            </button>
            <nav
              className={`nav-links${navOpen ? " nav-links-open" : ""}`}
              aria-label="Primary"
            >
              <Link to="/" onClick={() => setNavOpen(false)}>
                Home
              </Link>
              <Link to="/resume" onClick={() => setNavOpen(false)}>
                Resume
              </Link>
              <Link to="/projects" onClick={() => setNavOpen(false)}>
                Projects
              </Link>
              <Link to="/contact" onClick={() => setNavOpen(false)}>
                Contact
              </Link>
              <Link to="/chat" onClick={() => setNavOpen(false)}>
                Chat
              </Link>
            </nav>
          </div>
        </header>
      )}
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/resume" element={<Resume />} />
          <Route path="/projects" element={<Projects />} />
          <Route path="/chat" element={<Chat />} />
        </Routes>
      </main>
      <canvas
        style={{ display: "none" }}
        id="displayCanvas"
        width="1800"
        height="1000"
      >
        Your browser does not support HTML5 canvas.
      </canvas>
    </div>
  );
}

export default App;
